const HEBREW_RE = /^[\u0590-\u05FF\s]+$/;
const ENGLISH_RE = /^[A-Za-z\s'-]+$/;
const MIN_NAME_LENGTH = 2;

/**
 * Validate an English name field.
 * Returns an i18n error key or null if valid.
 */
export function validateEnglishName(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return 'validation.required';
  if (trimmed.length < MIN_NAME_LENGTH) return 'validation.minTwoChars';
  if (!ENGLISH_RE.test(trimmed)) return 'validation.englishLettersOnly';
  return null;
}

/**
 * Validate a Hebrew name field.
 * Returns an i18n error key or null if valid.
 */
export function validateHebrewName(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return 'validation.required';
  if (trimmed.length < MIN_NAME_LENGTH) return 'validation.minTwoChars';
  if (!HEBREW_RE.test(trimmed)) return 'validation.hebrewLettersOnly';
  return null;
}

/**
 * Validate a phone number field.
 * Returns an i18n error key or null if valid.
 */
export function validatePhone(value: string): string | null {
  if (!value.trim()) return 'validation.phoneRequired';
  if (value.replace(/\D/g, '').length < 9) return 'validation.phoneMinDigits';
  return null;
}
